import { Component, OnInit } from '@angular/core';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/services/alert.service';
import { Home } from '../../models/home/home.model';
import { Textarea } from '../../models/editors/textarea.model';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';
import { Textbox } from '../../models/editors/textbox.model';

@Component({
  selector: 'swb-home-bottom-text',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class HomeBottomTextComponent extends InlineFormBase<Home> implements OnInit {
  public url = 'home';
  public headerTitle = 'Text a video';
  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'bottom_text',
        label: 'Blokový text na konci hlavní stránky',
        isMultilang: true,
        wysiwyg: 'home-bottom-text'
      }),
      new Textbox({
        key: 'video_url',
        label: 'Adresa YouTube videa',
        isMultilang: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
